// /opt/isp_erp/frontend/src/pages/admin/clientes/ClientesPorEstado.jsx
// Antes descargaba todos los clientes del estado. Ahora reutiliza la lista paginada y con búsqueda en el servidor.
import React from "react";
import { useParams } from "react-router-dom";
import UsuariosClientes from "./UsuariosClientes";
import "./ClientesPorEstado.css";

const ESTADOS = { activos: "ACTIVO", retirados: "RETIRADO", suspendidos: "SUSPENDIDO" };
const TITULOS = { activos: "Clientes Activos", retirados: "Clientes Retirados", suspendidos: "Clientes Suspendidos" };

export default function ClientesPorEstado() {
  const { estado } = useParams();
  return <UsuariosClientes estadoInicial={ESTADOS[estado] || "todos"} titulo={TITULOS[estado] || "Clientes"} />;
}
